export default "__VITE_ASSET__DghqaWo2__"